import React from 'react'
import { useTheme } from '../../context/ThemeContext'
import '../../styles/pricingStyle.css'

interface PricingProps {
  // Active, self-service plans from the public /plans API (see CompanyForm,
  // which owns the fetch so it can map the selected card onto a plan name).
  plans: any[]
  activeCard: any
  setActiveCard: (index: number) => void
}

const billingLabel = (plan: any): string => {
  if (plan?.billingMode === 'ONE_TIME') return plan?.headline || 'One-time payment'
  return plan?.headline || (plan?.billingInterval === 'year' ? 'Billed annually' : 'Billed monthly')
}

const priceUnit = (plan: any): string => {
  // One-time plans are charged once (no per-user/recurring suffix).
  if (plan?.billingMode === 'ONE_TIME') return 'once'
  return plan?.billingType === 'per_user'
    ? '/user/month'
    : plan?.billingInterval === 'year'
    ? '/user/year'
    : '/month'
}

const Pricing: React.FC<PricingProps> = ({ plans, activeCard, setActiveCard }) => {
  const { theme } = useTheme()

  // Resolve text colour independent of the active state so prices are always
  // legible. Active cards sit on a light-blue background (dark text); inactive
  // cards sit on the modal background (follow the theme). Previously the colour
  // only resolved once a card was active, so prices appeared blank until click.
  const textColor = (index: number) =>
    activeCard === index ? '#2e2e2e' : theme === 'dark' ? '#e0e0e0' : '#2e2e2e'

  if (!plans || plans.length === 0) {
    return (
      <section id='pricing'>
        <div className='my-5 mx-2 text-center text-gray-500'>Loading plans…</div>
      </section>
    )
  }

  return (
    <section id='pricing'>
      <div className='my-5 mx-2'>
        <div className='line m-auto'></div>
        <div className='row justify-content-center'>
          {plans.map((plan, index) => (
            <div
              key={plan.id ?? index}
              className='col-lg-6 col-md-6 my-2 col-sm-12 col-sx-12'
            >
              <div
                className={`col-lg-12 col-md-12 my-2 col-sm-12 pricing-card pe-auto text-center mt-30 wow fadeIn py-2 px-0 ${
                  activeCard === index ? 'active' : ''
                }`}
                data-wow-duration='1s'
                data-wow-delay='0.2s'
                onClick={() => setActiveCard(index)}
              >
                <div className='pricing-content mt-30'>
                  <h3 className='pricing-title wow fadeInUp' style={{ color: textColor(index) }}>
                    {plan.displayName ?? plan.name}
                  </h3>
                  <div className='mt-5 wow fadeInUp' style={{ color: textColor(index) }}>
                    <span className='mb-2 dollar'>$</span>{' '}
                    <span className='price'>{Number(plan.price).toFixed(2)}</span> {priceUnit(plan)}
                  </div>
                  <div className='price-duration p-3 w-100 mt-3 mb-5'>{billingLabel(plan)}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default Pricing
